import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CarouselPlansComponent } from 'src/app/shared/components/carousel-plans/carousel-plans.component';
import { CarouselItem } from 'src/app/shared/components/carousel-plans/carousel-plans.model';
import { ActivatedRoute, Router } from '@angular/router';
import { OperationType } from '../finalizar-pagamento/finalizar-pagamento.component';
import { PlanService } from 'src/app/core/services/plan.service';
import {
  BenefitsModel,
  MemberPlanDetailModel,
  PeriodicitiModel,
  Plan,
} from 'src/app/shared/models/planModel';
import { CommonService } from 'src/app/core/services/common.service';
import { CustomCurrencyPipe } from 'src/app/shared/pipe/custom-currency.pipe';
import {
  MemberService,
  MemberSituationEnum,
} from 'src/app/core/services/member.service';
import { UserService } from 'src/app/core/services/user.service';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { CommonModule, Location } from '@angular/common';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';
import { StyleContentPlan } from 'src/app/shared/models/styleContent';
import { Page } from 'src/app/shared/models/Page';
import { AppModalComponent } from 'src/app/shared/components/app-modal/app-modal.component';
import { UserModel } from 'src/app/shared/models/userModel';
import { PaymentInvoiceModalData } from 'src/app/shared/components/payment-invoice-modal/payment-invoice-modal.component';
import { PaymentType } from 'src/app/shared/models/paymentData';
import { ModalService } from 'src/app/core/services/modal.service';
import { PaymentDataService } from 'src/app/core/services/payment-data.service';
import { PaymentModalComponent } from 'src/app/shared/components/payment-modal/payment-modal.component';
import { PlanPaymentsService } from 'src/app/core/services/plan-payments.service';
import { PlanPaymentUpgradeModel } from 'src/app/shared/models/planPaymentsModel';
import { ReplaceTextPipe } from "../../shared/pipe/replace-text.pipe";
import { ModalPlanSelectionComponent } from 'src/app/shared/components/modal-plan-selection/modal-plan-selection.component';
import { PlanCategory } from 'src/app/shared/models/planCategoryModel';
import { PlanCategoryService } from 'src/app/core/services/plan-category.service';

@Component({
  selector: 'app-upgrade-plano',
  standalone: true,
  imports: [
    CarouselPlansComponent,
    PaymentModalComponent,
    AppButtonComponent,
    CommonModule,
    AppModalComponent,
    ReplaceTextPipe,
    ModalPlanSelectionComponent
  ],
  templateUrl: './upgrade-plano.component.html',
  styleUrl: './upgrade-plano.component.scss',
})
export class UpgradePlanoComponent implements OnInit, AfterViewInit, OnDestroy {
  private _destroy$ = new Subject<void>();

  items: CarouselItem[] = [];
  isMobile = window.innerWidth < 768;
  currencyPipe = new CustomCurrencyPipe();
  buttonOptionsCard: any;
  //
  notRenewed: boolean;
  canChekPix = true;
  modalId = 'payment-modal';
  showModalNotRenewed = false;
  selectOperationTypeModal = {
    id: 'selectOperationTypeModal',
    title: 'Selecione o tipo de operação',
    bodyMessage: 'Selecione o tipo de operação que deseja realizar',
    confirmLabel: 'Adesão',
    showCloseBtn: true,
    cancelLabel: 'Renovação',
    backdropType: 'static',
    showThirdBtn: false,
    thirdLabel: '',
    size: '',
  };
  user: UserModel;
  PaymentType = PaymentType;
  paymentType: PaymentType;
  paymentInvoiceModalData: PaymentInvoiceModalData;
  orderModalId = 'orderModal';
  orderModalBodyMessage =
    'Você já possui um pedido de plano em andamento. Deseja continuar com o pedido ou cancelar?';
  //
  buttonOptionsCardSpecial: any;

  buttonBackOptions = {
    buttonText: 'Voltar',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px',
  };

  newBtn = {
    buttonText: 'Adesão',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-5 btn-primary',
    btnDisabledBackground: '#f2e2b2',
    btnDisabledTextColor: '#000000',
  };

  memberId: string;
  styles: { [key: string]: string };
  selectPlan = false;
  renewPlan = false;
  showPlans = false;
  planDetail: any;

  operation: OperationType = this.paymentDataService.getOperationType();
  tryingToRenew: boolean = false;
  hasSecondaryPlan: boolean = false;
  isPlanSecondary: boolean = localStorage.getItem('isSecondaryPlan') === 'true';
  enableRenewalButton = localStorage.getItem('enableRenewalButton') === 'true';

  // Modal de seleção de planos
  showPlanModal = false;
  modalCategories: PlanCategory[] = [];
  planCategories: PlanCategory[] = [];
  selectedCategoryIndex = 0;
  fullPlans: Plan[] = [];

  constructor(
    private router: Router,
    private planService: PlanService,
    private commonService: CommonService,
    private memberService: MemberService,
    private userService: UserService,
    private location: Location,
    private activateRoute: ActivatedRoute,
    private alertService: AlertService,
    private modalService: ModalService,
    private paymentDataService: PaymentDataService,
    private planPaymentsService: PlanPaymentsService,
    private replaceTextPipe: ReplaceTextPipe,
    private planCategoryService: PlanCategoryService
  ) {
    this.user = this.userService.currentUserValue as UserModel;
    if (this.activateRoute.snapshot.url[0].path === 'selecionar-plano') {
      this.selectPlan = true;
    }

    if (this.activateRoute.snapshot.url[0].path === 'renovar-plano') {
      this.renewPlan = true;
    }

    this.getPlanConfig();

    this.userService.currentUser.pipe(takeUntil(this._destroy$)).subscribe((user: any) => {
      this.memberId = user?.id || this.memberService.getMemberId();
      if (!this.memberId) {
        this.router.navigate(['/cadastro-socio']);
      }
    });
  }
  //
  onModalConfirm() {
    console.log('Method not implemented.');
  }

  ngOnInit(): void {
    if (this.user.memberPlans?.find((plan) => plan.isSecondaryPlan)) {
      this.hasSecondaryPlan = true;
    }

    this.notRenewed =
      this.user?.memberSituation?.id === MemberSituationEnum.NaoRenovado;

    // Carregar categorias de planos
    this.loadPlanCategories();
  }

  ngAfterViewInit(): void {
    if (!this.enableRenewalButton) {
      if (this.user?.cpf) {
        this.getMemberPublicInfo();
      } else {
        this.getAllPlans();
      }
      return;
    }

    if (this.isPlanSecondary) {
      this.router.navigate(['/dashboard']);
      return;
    }
    if (this.notRenewed) {
      if (this.hasSecondaryPlan) {
        this.selectOperationTypeModal.showThirdBtn = true;
        this.selectOperationTypeModal.thirdLabel = 'Secundário';
        this.selectOperationTypeModal.size = 'modal-lg';
      }
      this.showModalNotRenewed = true;
      setTimeout(() => {
        this.modalService.open(this.selectOperationTypeModal.id);
      }, 200);
      return;
    } else if (
      this.memberService.isMemberSituationInEnum(
        this.user?.memberSituation?.id as string
      ) &&
      this.hasSecondaryPlan
    ) {
      this.selectOperationTypeModal.showThirdBtn = true;
      this.selectOperationTypeModal.showCloseBtn = false;
      this.selectOperationTypeModal.thirdLabel = 'Secundário';
      this.showModalNotRenewed = true;
      setTimeout(() => {
        this.modalService.open(this.selectOperationTypeModal.id);
      }, 200);
    } else {
      if (this.user?.cpf) {
        this.getMemberPublicInfo();
      } else {
        this.getAllPlans();
      }
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  getMemberPublicInfo() {
    this.activateRoute.queryParams.pipe(takeUntil(this._destroy$)).subscribe((params) => {
      const newAdesion = params['newAdesion'] === 'false' ? false : true;

      this.memberService.getMemberPublicInfo().pipe(takeUntil(this._destroy$)).subscribe((res) => {
        this.user = res;
        if (
          (!this.isPlanSecondary && this.user?.memberPlans?.length == 0) ||
          this.memberService.isMemberSituationInEnum(
            this.user?.memberSituation?.id as string
          )
        ) {
          if (this.user?.orders?.length == 0) {
            if (newAdesion === false || this.operation == OperationType.RENEW) {
              this.getPlanbyId();
            } else {
              this.getAllPlans();
            }
          } else {
            if (!this.checkExpirationQRCode()) {
              this.showOrderModal();
              this.getAllPlans();
            } else {
              this.alertService.showAlert(
                AlertType.INFO,
                this.replaceTextPipe.transform('Você ainda não possui plano ativo, selecione um plano para continuar.')
              );
              this.getAllPlans();
            }
          }
        } else {
          this.getPlanbyId();
        }
      });
    });
  }

  getOperationTypeLabel() {
    this.tryingToRenew = false;
    switch (this.operation) {
      case OperationType.UPGRADE:
      case OperationType.UPGRADE_RECURRENCE:
        return 'o upgrade';
      case OperationType.RENEW:
        return 'a renovação';
      case OperationType.EARLY_RENEW:
        return 'a renovação antecipada';
      default:
        return 'a adesão';
    }
  }

  getNoPlansMessage(): string {
    this.tryingToRenew = false;
    switch (this.operation) {
      case OperationType.UPGRADE:
      case OperationType.UPGRADE_RECURRENCE:
        return 'Seu Plano não possui possíveis Upgrades';
      case OperationType.RENEW:
        this.tryingToRenew = true;
        return 'Seu Plano não possui possíveis renovações';
      case OperationType.EARLY_RENEW:
        return 'Seu Plano não possui possíveis renovações antecipadas';
      default:
        return 'Não existem planos disponíveis para adesão';
    }
  }

  showOrderModal() {
    this.modalService.open(this.orderModalId);
  }

  checkExpirationQRCode(): boolean {
    if (this.user?.orders && this.user.orders.length > 0) {
      const createdAt = new Date(
        this.user?.orders[this.user?.orders?.length - 1].createdAt
      );
      const now = new Date();

      // Diferença em milissegundos entre a data atual e a data de criação
      const differenceInMs = now.getTime() - createdAt.getTime();

      // Converter 58 minutos para milissegundos
      const timeToCompare = 58 * 60 * 1000; // 58 minutos

      // Comparar a diferença
      if (differenceInMs >= timeToCompare) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  onOrderModalConfirm(event: any): void {
    if (event) {
      if (this.user?.orders && this.user.orders.length > 0) {
        this.paymentInvoiceModalData = {
          invoiceNumber: '',
          invoiceCode: this.user.orders[this.user.orders.length - 1].qrCodeData,
          invoiceCodeImg:
            this.user.orders[this.user.orders.length - 1].qrCodeImageUrl,
        };
        if (this.user.orders[0].qrCodeData) {
          this.paymentType = PaymentType.PIX;
        }
        this.checkPixPayment(this.user.orders[0].id);
        this.modalService.open(this.modalId);
      }
    }
  }

  checkPixPayment(orderId: any): void {
    this.paymentDataService.getPaymentOrder(orderId).subscribe((data) => {
      if (data.status != 'paid') {
        if (this.canChekPix) {
          setTimeout(() => {
            this.checkPixPayment(orderId);
          }, 3000);
        }
      } else {
        this.paymentDataService.setOperationType(
          this.operation || OperationType.NEW
        );
        this.router.navigate(['/finalizar-pagamento']);
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobile = (event.target as Window).innerWidth < 768;
  }

  carouselResponse(plano: CarouselItem): void {
    // Verificar se o plano pertence a alguma categoria retornada pela API
    const planCategory = this.findPlanCategory(plano.id);

    if (planCategory && planCategory.plans && planCategory.plans.length > 0) {
      // Preparar todas as categorias com planos completos para o modal
      this.modalCategories = this.planCategories
        .filter(cat => cat.plans && cat.plans.length > 0)
        .map(cat => {
          const fullPlans = cat.plans
            .map(planSimple => {
              // Buscar o plano completo primeiro (pode estar ou não no carrossel)
              const fullPlan = this.findFullPlanById(planSimple.id);

              // Se não encontrar, pular (não deveria acontecer se API estiver consistente)
              if (!fullPlan) return null;

              return {
                id: planSimple.id,
                name: planSimple.name,
                planName: planSimple.name,
                amount: fullPlan.amount || 0,
                imgPortalPlan: fullPlan.imgPortalPlan,
                description: fullPlan.periodicities?.map((p: any) => p.description).join(', ') || '',
                benefits: fullPlan.benefits?.map(b => ({
                  id: b.id,
                  benefitName: b.benefitName,
                  isActive: b.isActive ?? false,
                  order: b.order,
                  diferential: b.diferential ?? false
                })) || [],
                showOnPortal: fullPlan.showOnPortal
              };
            })
            .filter(plan => plan !== null);

          return {
            ...cat,
            plans: fullPlans as any[]
          };
        })
        .filter(cat => cat.plans.length > 0);

      if (this.modalCategories.length > 0) {
        // Encontrar o índice da categoria do plano selecionado
        this.selectedCategoryIndex = this.modalCategories.findIndex(cat => cat.id === planCategory.id);
        if (this.selectedCategoryIndex === -1) {
          this.selectedCategoryIndex = 0;
        }

        this.showPlanModal = true;
        return;
      }
    }

    // Se não encontrou categoria ou categoria não tem planos, ir direto para pagamento
    this.memberService.setMemberId(this.memberId);
    this.planService.setPlanSelected(plano);
    if (this.selectPlan && this.operation != OperationType.RENEW) {
      this.paymentDataService.setOperationType(OperationType.NEW);
    }

    this.router.navigate([`/finalizar-pagamento`]);
  }

  private extractAmountFromString(valorString: string): number {
    if (valorString === 'Gratuito') {
      return 0;
    }
    const match = valorString.match(/R\$\s*([\d.,]+)/);
    if (match) {
      return parseFloat(match[1].replace('.', '').replace(',', '.'));
    }
    return 0;
  }

  private extractImageId(src: string): string {
    // Extrai o ID da imagem da URL (último segmento)
    const parts = src.split('/');
    return parts[parts.length - 1] || '';
  }

  findPlanCategory(planId: string | undefined): PlanCategory | undefined {
    if (!planId) return undefined;
    return this.planCategories.find(category =>
      category.plans?.some(plan => plan.id === planId)
    );
  }

  findFullPlanById(planId: string): Plan | undefined {
    return this.fullPlans.find(plan => plan.id === planId);
  }

  loadPlanCategories() {
    this.planCategoryService.getAll(0, 100).subscribe({
      next: (response: any) => {
        // A API pode retornar array direto ou objeto paginado
        this.planCategories = Array.isArray(response) ? response : (response.content || []);
        console.log('Categorias de planos carregadas:', this.planCategories);
      },
      error: (error) => {
        // Se der erro ao carregar categorias (ex: 403), continua sem categorias
        console.warn('Não foi possível carregar as categorias de planos:', error);
        this.planCategories = [];
      }
    });
  }

  hasDiferencialBenefits(plan: Plan): boolean {
    if (!plan.benefits) return false;
    return plan.benefits.some(b => b.diferential === true && b.isActive);
  }

  onClosePlanModal() {
    this.showPlanModal = false;
    this.modalCategories = [];
  }

  onSelectPlanFromModal(planId: string) {
    this.showPlanModal = false;
    this.modalCategories = [];

    // Tentar encontrar o plano nos items do carrossel primeiro
    let selectedPlan = this.items.find(item => item.id === planId);

    // Se não encontrar (plano com showOnPortal = false), buscar em fullPlans e criar o item
    if (!selectedPlan) {
      const fullPlan = this.findFullPlanById(planId);
      if (fullPlan) {
        const planCategory = this.findPlanCategory(planId);
        selectedPlan = {
          id: fullPlan.id,
          title: fullPlan.planName,
          enableItems: fullPlan.benefits
            ?.filter((benefit: BenefitsModel) => benefit.isActive)
            .sort((a: BenefitsModel, b: BenefitsModel) => a.order - b.order)
            .map((benefit: BenefitsModel) => benefit.benefitName) as string[],
          disableItems: fullPlan.benefits
            ?.filter((benefit: BenefitsModel) => !benefit.isActive)
            .map((benefit: BenefitsModel) => benefit.benefitName) as string[],
          periodo: fullPlan.periodicities
            ?.map((period: PeriodicitiModel) => period.description)
            .join(', '),
          valor: fullPlan.amount === 0 || fullPlan.amount === null
            ? 'Gratuito'
            : `${this.currencyPipe.transform(fullPlan.amount)}/mês`,
          src: this.commonService.getImageStr(fullPlan.imgPortalPlan?.id as string),
          highlight: fullPlan.highlightOnPortal ?? false,
          buttonOptions: fullPlan.highlightOnPortal
            ? this.buttonOptionsCard
            : this.buttonOptionsCardSpecial,
          planCategoryId: planCategory?.id
        };
      }
    }

    if (selectedPlan) {
      this.memberService.setMemberId(this.memberId);
      this.planService.setPlanSelected(selectedPlan);
      if (this.selectPlan && this.operation != OperationType.RENEW) {
        this.paymentDataService.setOperationType(OperationType.NEW);
      }
      this.router.navigate([`/finalizar-pagamento`]);
    }
  }

  private getAllPlansUpgradeRenewal(planList: any[]): void {
    let filteredPlans = planList.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.plan === item.plan)
    );
    let counter = filteredPlans.length;

    filteredPlans.forEach((planUpgrade: any) => {
      this.planService.getPlanById(planUpgrade.plan).subscribe((plan: Plan) => {
        // Armazenar TODOS os planos completos (incluindo showOnPortal = false)
        this.fullPlans.push(plan);

        // Adicionar ao carrossel apenas se showOnPortal !== false
        if (plan.showOnPortal !== false) {
          const planCategory = this.findPlanCategory(plan.id);

          this.items.push({
            id: plan.id,
            title: plan.planName,
            enableItems: plan.benefits
              ?.filter((benefit: BenefitsModel) => benefit.isActive)
              .sort((a: BenefitsModel, b: BenefitsModel) => a.order - b.order)
              .map((benefit: BenefitsModel) => benefit.benefitName) as string[],
            disableItems: plan.benefits
              ?.filter((benefit: BenefitsModel) => !benefit.isActive)
              .map((benefit: BenefitsModel) => benefit.benefitName) as string[],
            periodo: plan.periodicities
              .map((period: PeriodicitiModel) => period.description)
              .join(', '),
            valor: plan.amount === 0 || plan.amount === null
              ? 'Gratuito'
              : `${this.currencyPipe.transform(plan.amount)}/mês`,
            src: this.commonService.getImageStr(plan.imgPortalPlan?.id as string),
            highlight: plan.highlightOnPortal ?? false,
            buttonOptions: plan.highlightOnPortal
              ? this.buttonOptionsCard
              : this.buttonOptionsCardSpecial,
            planCategoryId: planCategory?.id
          });
        }

        counter--;
        if (counter == 0) {
          this.items = this.items.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.id === item.id)
          );
          this.items.sort((a, b) => {
            let item1 = parseFloat(
              a.valor
                .split('/')[0]
                .replace('R$', '')
                .replace('.', '')
                .replace(',', '.')
            );
            let item2 = parseFloat(
              b.valor
                .split('/')[0]
                .replace('R$', '')
                .replace('.', '')
                .replace(',', '.')
            );
            return item1 - item2;
          });
          this.showPlans = true;
        }
      });
    });
    this.showPlans = true;
  }

  private getAllPlans(): void {
    this.planService.getPublicPlans().subscribe((plans: Page<Plan>) => {
      // Armazenar TODOS os planos completos para usar no modal (incluindo showOnPortal = false)
      this.fullPlans = plans.content?.filter((plan: any) => plan.isActive) || [];

      // Filtrar apenas os planos que devem aparecer no carrossel (showOnPortal = true)
      const plansForCarousel = this.fullPlans.filter((plan: any) => plan.showOnPortal === true);

      plansForCarousel.forEach((plan: any) => {
        const planCategory = this.findPlanCategory(plan.id);

        this.items.push({
          id: plan.id,
          title: plan.planName,
          enableItems: plan.benefits
            ?.filter((benefit: BenefitsModel) => benefit.isActive)
            .sort((a: BenefitsModel, b: BenefitsModel) => a.order - b.order)
            ?.map(
              (benefit: BenefitsModel) => benefit.benefitName
            ) as string[],
          disableItems: plan.benefits
            ?.filter((benefit: BenefitsModel) => !benefit.isActive)
            ?.map(
              (benefit: BenefitsModel) => benefit.benefitName
            ) as string[],
          periodo: plan.periodicities
            ?.map((period: PeriodicitiModel) => period.description)
            .join(', '),
          valor: `${plan.amount
            ? this.currencyPipe.transform(plan.amount) + '/mês'
            : 'Gratuito'
            }`,
          src:
            this.commonService.getImageStr(
              plan.imgPortalPlan?.id as string
            ) || (localStorage.getItem('imageLogo') as string),
          highlight: plan.highlightOnPortal ?? false,
          buttonOptions: plan.highlightOnPortal
            ? this.buttonOptionsCard
            : this.buttonOptionsCardSpecial,
          visible: plan.saleLocations.find(
            (location: any) => location.name === 'Site'
          ),
          position: plan.position,
          planCategoryId: planCategory?.id
        });
      });
      // Ordenar os planos por posição
      this.items.sort((a: any, b: any) => a.position - b.position);
    });
    this.showPlans = true;
  }

  private getLastExpiredMemberPlan(): void {
    this.planService.getLastExpiredMemberPlan(this.user.id).subscribe({
      next: (res: MemberPlanDetailModel) => {
        this.planDetail = res;
        if (!this.planDetail || this.planDetail.length == 0) {
          this.alertService.showAlert(
            AlertType.DANGER,
            this.replaceTextPipe.transform('Não foi possível encontrar um plano para renovação.')
          );
          return;
        }

        this.planPaymentsService
          .getPlanPaymentsRenewals(this.planDetail.id)
          .subscribe((planList: PlanPaymentUpgradeModel[]) => {
            this.getAllPlansUpgradeRenewal(planList);
          });
      },
      error: (error: any) => {
        console.log('Error: ', error);
      },
    });
  }

  getPreviousPlansList() {
    this.planService
      .getPreviousPlansDetail(this.user.id)
      .subscribe((res: any[]) => {
        localStorage.setItem('previousMemberPlansId', res[0].id);
        this.planPaymentsService
          .getPlanPaymentsRenewals(res[0].id)
          .subscribe((planList: PlanPaymentUpgradeModel[]) => {
            // Remove duplicados utilizando o plan
            planList = planList.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.plan === item.plan)
            );

            let counter = planList.length;

            planList.forEach((planUpgrade: any) => {
              this.planService
                .getPlanById(planUpgrade.plan)
                .subscribe((plan: Plan) => {
                  // Armazenar TODOS os planos completos (incluindo showOnPortal = false)
                  this.fullPlans.push(plan);

                  // Adicionar ao carrossel apenas se showOnPortal !== false
                  if (plan.showOnPortal !== false) {
                    const planCategory = this.findPlanCategory(plan.id);

                    this.items.push({
                      id: plan.id,
                      title: plan.planName,
                      enableItems: plan.benefits
                        ?.filter((benefit: BenefitsModel) => benefit.isActive)
                        .sort((a: BenefitsModel, b: BenefitsModel) => a.order - b.order)
                        .map(
                          (benefit: BenefitsModel) => benefit.benefitName
                        ) as string[],
                      disableItems: plan.benefits
                        ?.filter((benefit: BenefitsModel) => !benefit.isActive)
                        .map(
                          (benefit: BenefitsModel) => benefit.benefitName
                        ) as string[],
                      periodo: plan.periodicities
                        .map((period: PeriodicitiModel) => period.description)
                        .join(', '),
                      valor: plan.amount === 0 || plan.amount === null
                        ? 'Gratuito'
                        : `${this.currencyPipe.transform(plan.amount)}/mês`,
                      src: this.commonService.getImageStr(
                        plan.imgPortalPlan?.id as string
                      ),
                      highlight: plan.highlightOnPortal ?? false,
                      buttonOptions: plan.highlightOnPortal
                        ? this.buttonOptionsCard
                        : this.buttonOptionsCardSpecial,
                      planCategoryId: planCategory?.id
                    });
                  }

                  counter--;
                  if (counter == 0) {
                    this.items = this.items.filter(
                      (item, index, self) =>
                        index === self.findIndex((t) => t.id === item.id)
                    );
                    this.items.sort((a, b) => {
                      let item1 = parseFloat(
                        a.valor
                          .split('/')[0]
                          .replace('R$', '')
                          .replace('.', '')
                          .replace(',', '.')
                      );
                      let item2 = parseFloat(
                        b.valor
                          .split('/')[0]
                          .replace('R$', '')
                          .replace('.', '')
                          .replace(',', '.')
                      );
                      return item1 - item2;
                    });
                    this.showPlans = true;
                  }
                });
            });
            this.showPlans = true;
          });
      });
  }

  getPlanbyId(): void {
    if (this.user.memberPlans) {
      if (this.renewPlan) {
        if (this.user?.memberSituation?.id != MemberSituationEnum.NaoRenovado) {
          this.planService.getCurrentPlanDetail(this.user.id).subscribe({
            next: (res: MemberPlanDetailModel) => {
              this.planDetail = res;
              this.planPaymentsService
                .getPlanPaymentsRenewals(this.planDetail.id)
                .subscribe((planList: PlanPaymentUpgradeModel[]) => {
                  this.getAllPlansUpgradeRenewal(planList);
                });
            },
            error: (error: any) => {
              console.log('Error: ', error);
            },
          });
        } else {
          this.planService.getLastExpiredMemberPlan(this.user.id).subscribe({
            next: (res: MemberPlanDetailModel) => {
              this.planDetail = res;
              this.planPaymentsService
                .getPlanPaymentsRenewals(this.planDetail.id)
                .subscribe((planList: PlanPaymentUpgradeModel[]) => {
                  this.getAllPlansUpgradeRenewal(planList);
                });
            },
            error: (error: any) => {
              console.log('Error: ', error);
            },
          });
        }
      } else {
        this.planService.getCurrentPlanDetail(this.user.id).subscribe({
          next: (res: MemberPlanDetailModel) => {
            this.planDetail = res;
            this.planPaymentsService
              .getPlanPaymentsUpgrades(this.planDetail.id)
              .subscribe((planList: PlanPaymentUpgradeModel[]) => {
                this.getAllPlansUpgradeRenewal(planList);
              });
          },
          error: (error: any) => {
            console.log('Error: ', error);
          },
        });
      }
    }
  }

  private getPlanConfig(): void {
    this.planService.getPlanConfig().subscribe((config: StyleContentPlan) => {
      const style = config;

      this.setStyles(style);
      this.setBtnStyle(style);
    });
  }

  private setStyles(styles: StyleContentPlan): void {
    this.styles = {
      carouselType: styles.carouselType,
      carouselInterval: styles.carouselInterval,
      '--show-section': styles.showSection ? 'flex' : 'none',
      '--show-subtitle': styles.showSubtitle ? 'block' : 'none',
      '--title-size': this.commonService.getRemFontSize(
        styles.titleSize,
        this.isMobile
      ),
      '--title-color': styles.titleColor,
      '--subtitle-size': this.commonService.getRemFontSize(
        styles.subtitleSize,
        this.isMobile
      ),
      '--subtitle-color': styles.subtitleColor,
      '--background-general-color': styles.backgroundGeneralColor,
      '--background-general-image':
        styles.backgroundGeneralType == 'Imagem'
          ? `url(${this.commonService.getImageStr(
            styles.backgrounGeneralImage?.id
          )})`
          : 'none',

      '--card-default-title-size': this.commonService.getRemFontSize(
        styles.cardDefaultTitleSize,
        this.isMobile
      ),
      '--card-default-title-color': styles.cardDefaultTitleColor,
      '--card-default-description-size': this.commonService.getRemFontSize(
        styles.cardDefaultDescriptionSize,
        this.isMobile
      ),
      '--card-default-description-color': styles.cardDefaultDescriptionColor,
      '--card-default-price-size': this.commonService.getRemFontSize(
        styles.cardDefaultPriceSize,
        this.isMobile
      ),
      '--card-default-price-color': styles.cardDefaultPriceColor,
      '--card-default-background-color': styles.cardDefaultBackgroundColor,
      '--card-default-background-image':
        styles.cardDefaultBackgroundType == 'Imagem'
          ? `url(${this.commonService.getImageStr(
            styles.cardDefaultBackgroundImage?.id
          )})`
          : 'none',

      '--card-special-title-size': this.commonService.getRemFontSize(
        styles.cardSpecialTitleSize,
        this.isMobile
      ),
      '--card-special-title-color': styles.cardSpecialTitleColor,
      '--card-special-description-size': this.commonService.getRemFontSize(
        styles.cardSpecialDescriptionSize,
        this.isMobile
      ),
      '--card-special-description-color': styles.cardSpecialDescriptionColor,
      '--card-special-price-size': this.commonService.getRemFontSize(
        styles.cardSpecialPriceSize,
        this.isMobile
      ),
      '--card-special-price-color': styles.cardSpecialPriceColor,
      '--card-special-background-color': styles.cardSpecialBackgroundColor,
      '--card-special-background-image':
        styles.cardSpecialBackgroundType == 'Imagem'
          ? `url(${this.commonService.getImageStr(
            styles.cardSpecialBackgroundImage?.id
          )})`
          : 'none',

      '--side-buttons-color': styles.sideButtonsColor,
      '--side-buttons-border-color': styles.sideButtonsBorderColor,
      '--side-buttons-border': styles.sideButtonsBorder ? '1px solid' : 'none',
      '--side-buttons-icon-color': styles.sideButtonsColor
    };
  }

  private setBtnStyle(styles: StyleContentPlan): void {
    this.buttonOptionsCard = {
      primaryColor: styles.cardDefaultButtonColor,
      secondaryColor: styles.cardDefaultButtonColor,
      buttonText: styles.cardDefaultButtonText,
      buttonTextColor: styles.cardDefaultButtonTextColor,
      borderRadius: '25px',
      buttonBorderWidth: styles.cardDefaultButtonHasBorder ? '1px' : 'none',
      buttonBorderColor: styles.cardDefaultButtonBorderColor,
      buttonSize: 'btn btn-md',
      fontSize: 12,
    };

    this.buttonOptionsCardSpecial = {
      primaryColor: styles.cardSpecialButtonColor,
      secondaryColor: styles.cardSpecialButtonColor,
      buttonText: styles.cardSpecialButtonText,
      buttonTextColor: styles.cardSpecialButtonTextColor,
      borderRadius: '25px',
      buttonBorderWidth: styles.cardSpecialButtonHasBorder ? '1px' : 'none',
      buttonBorderColor: styles.cardSpecialButtonBorderColor,
      buttonSize: 'btn btn-md',
      fontSize: 12,
    };
  }

  onSelectOperationTypeModalConfirm(isNewPlan: any): void {
    if (isNewPlan) {
      this.paymentDataService.setOperationType(OperationType.NEW);
      this.operation = OperationType.NEW;
      if (this.user?.cpf) {
        this.getMemberPublicInfo();
      } else {
        this.getAllPlans();
      }
    } else {
      this.paymentDataService.setOperationType(OperationType.RENEW);
      this.operation = OperationType.RENEW;

      this.getPreviousPlansList();
    }
  }

  onSelectOperationTypeModalThird(event: any): void {
    if (event) {
      this.getSecondaryMemberPlanDetail();
    }
  }

  getSecondaryMemberPlanDetail() {
    this.memberService.getCurrentSecondaryPlanDetail(this.user.id).subscribe(
      (res: any) => {
        localStorage.setItem('isSecondaryPlan', 'true');
        localStorage.setItem('secondaryPlanDetail', JSON.stringify(res));
        localStorage.setItem('userIdSecondaryPlan', this.user.id);
        window.location.reload();
      },
      (error: any) => {
        console.log('Error: ', error);
        this.alertService.showAlert(
          AlertType.DANGER,
          this.replaceTextPipe.transform('Erro ao carregar plano')
        );
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    );
  }

  back(): void {
    this.location.back();
  }
}
